import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

import "./index.css";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import AlertModalProvider from "./Context/AlertModalContext";
import SocketProvider from "./Context/SockerContext";
import { AppContextProvider } from "./Context/UseContext";
import { OnlineStatusProvider } from "./Context/OnlineStatusContext";
import UserProfileProvider from "./components/userflow/components/context/UserProfileContext";
import ProfileProvider from "./components/userflow/components/context/ProfileContext";
import QuestionProvider from "./Context/QuentionContext";

//Toastify
import { NotificationProvider } from "./components/toast/NotificationProvider";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GCID}>
    <React.StrictMode>
      <SocketProvider>
        <ProfileProvider>
          <UserProfileProvider>
            <QuestionProvider>
              <AppContextProvider>
                <OnlineStatusProvider>
                  <AlertModalProvider>
                    <Elements stripe={stripePromise}>
                      <BrowserRouter
                        future={{
                          v7_startTransition: true,
                          v7_relativeSplatPath: true,
                        }}
                      >
                        {/* Wrap the whole app so any component can use useNotification */}
                        <NotificationProvider>
                          <App />
                        </NotificationProvider>
                      </BrowserRouter>
                    </Elements>
                  </AlertModalProvider>
                </OnlineStatusProvider>
              </AppContextProvider>
            </QuestionProvider>
          </UserProfileProvider>
        </ProfileProvider>
      </SocketProvider>
    </React.StrictMode>
  </GoogleOAuthProvider>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('SW registered: ', registration);
      })
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
